import lowerLocaleSort from './lowerLocaleSort';

// bind functions to the window so they can be used without module syntax in legacy code
window.lowerLocaleSort = lowerLocaleSort;
